<div class="customer-subscriptions">
  <kzn-table
    [data]="customerSubscriptions"
    [columns]="tableColumns"
    [rowActions]="tableRowActions"
    style="width: 100%"
    class="customer-subscriptions__table"
  >
    <ng-container header-right>
      <button
        type="button"
        class="customer-subscriptions__create-btn"
        (click)="openCreateSubscriptionDialog()"
      >
        <mat-icon>add</mat-icon>{{ 'createCustomerSubscription' | translate }}
      </button>
    </ng-container>
  </kzn-table>
</div>
